// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custome_address{
    display: flex;
    justify-content:space-between;
    align-items: center;
    width: 100%;
}

.custome_address input {
    margin-bottom: 0px ;
}

.date_and_dropdown_wrapper{
    /* width: 800px ; */
    display: flex;
    justify-content:end;
    align-items: center;
}

.drop_down .form-control{
    width: 150px;
}

.from_date , .to_date{
    display: flex;
    flex-direction: column;
    margin-top: -13px;
}

.from_date label{
    margin-bottom: 0px;
    font-size: 12px;
}
.to_date label{
    margin-bottom: 0px;
    font-size: 12px;
}

.from_date input, .to_date input{
    height: 30px;
}
 .to_date{
   margin-left: 10px;
}

.apply_btn{
    margin-left: 10px;
    margin-right: 10px;
}

.apply_btn button{
    height: 35px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}



`, "",{"version":3,"sources":["webpack://./src/Pages/DashboardPage/DashboardPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;CACC;GACE,iBAAiB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".custome_address{\n    display: flex;\n    justify-content:space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.custome_address input {\n    margin-bottom: 0px ;\n}\n\n.date_and_dropdown_wrapper{\n    /* width: 800px ; */\n    display: flex;\n    justify-content:end;\n    align-items: center;\n}\n\n.drop_down .form-control{\n    width: 150px;\n}\n\n.from_date , .to_date{\n    display: flex;\n    flex-direction: column;\n    margin-top: -13px;\n}\n\n.from_date label{\n    margin-bottom: 0px;\n    font-size: 12px;\n}\n.to_date label{\n    margin-bottom: 0px;\n    font-size: 12px;\n}\n\n.from_date input, .to_date input{\n    height: 30px;\n}\n .to_date{\n   margin-left: 10px;\n}\n\n.apply_btn{\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.apply_btn button{\n    height: 35px;\n    width: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
